export default __webpack_public_path__ + "static/media/ottoman-1-seat.d4417f75.webp";